export function isAcceptChildren(website: string): boolean {
    try {
        return !(website?.includes('yoonly') ?? false);
    } catch (error) {
        return true;
    }   
}